// extracted by mini-css-extract-plugin
module.exports = {"slider":"Request_slider__gL9XB"};